/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12.0606.6912a.825.825 0 0 0-1.6392.1338l-.0001 8.3534.0108.1338a.825.825 0 0 0 1.6392-.1338L12.0714.825l-.0108-.1338ZM1.8359 4.2502l4.7506.1623-.2065 4.777c-.0158.4533-.39.8082-.8358.7926a.7956.7956 0 0 1-.4842-.1857.8233.8233 0 0 1-.2865-.5154l-.0079-.148.0776-1.6317A8.7333 8.7333 0 0 0 3.549 9.4558a8.8496 8.8496 0 0 0-.1798.3957c-.4682 1.102-.7192 2.3127-.7192 3.5735 0 4.9291 3.9959 8.925 8.925 8.925 4.9291 0 8.925-3.9959 8.925-8.925 0-2.7646-1.2849-5.33-3.4348-7.0197a.825.825 0 0 1 1.0196-1.2973c2.5424 1.998 4.0652 5.0387 4.0652 8.317C22.15 19.2654 17.4154 24 11.575 24 5.7346 24 1 19.2654 1 13.425c0-2.197.6493-4.2723 1.8192-5.9974.3532-.5209.754-1.0099 1.1987-1.4607l-2.2394-.075c-.3962-.0138-.7157-.3157-.7707-.701L1 5.0429c.014-.403.3113-.7282.6903-.7846l.1456-.0081Z"
    clipRule="evenodd"
  />,
  'Restart'
);
